import { useSelector } from "react-redux";

import { selectAuth } from "redux/modules";

export function useUser() {
	const authStatus = useSelector(selectAuth);

	return authStatus;
}
